import { Helmet } from 'react-helmet-async';
import { Button, HelpInfo, Typography } from 'components';
import styles from './RejectedOffer.module.scss';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import TriangleIcon from 'assets/icons/yellow-warning.svg?react';
import { useTranslation } from 'react-i18next';
import { session, useSession } from 'session';

export default function RejectedOffer() {
  const { t } = useTranslation();
  const isAuthModeResolving = useSession((state) => state.mode === null);

  const handleLogout = () =>
    session.logout({ redirectTo: import.meta.env.VITE_HOMEPAGE_URL });

  return (
    <>
      <Helmet>
        <title>{t('rejected_offer:html_title')}</title>
      </Helmet>

      <div className={styles['box-wrapper']}>
        <CardWithIcon
          icon={<TriangleIcon />}
          heading={
            <Typography kind="h1" size="l" dataTest="rejectedOffer-title">
              {t('rejected_offer:title')}
            </Typography>
          }
          dataTest="rejectedOffer-card"
        >
          <Typography
            fontWeight={700}
            size="m"
            dataTest="rejectedOffer-subtitle"
          >
            {t('rejected_offer:sub_title')}
          </Typography>

          <Button
            dataTest="redirect-to-root"
            onClick={handleLogout}
            className={styles.button}
            pending={isAuthModeResolving}
          >
            {t('rejected_offer:button')}
          </Button>
        </CardWithIcon>

        <div className={styles.help}>
          <HelpInfo
            title={t('help_info:title')}
            text={t('help_info:text')}
            dataTest="rejectedOffer-helpInfo"
          />
        </div>
      </div>
    </>
  );
}
